module.exports = __webpack_public_path__ + "img/user_icon.8137efbc.jpeg";